export enum AppRoute {
    HOME = '/',
    PROFILE = '/profile',
    CLASS_DETAIL = '/class-detail'
}